// extracted by mini-css-extract-plugin
export default {"tablet":"482px","medium-tablet":"767px","desktop":"1025px"};